const deviceType = () =>
{
    if (window.outerWidth <= 425)
        return 'mobile'

    if (window.outerWidth <= 768)
        return 'tablet'

    return 'laptop'
}

export default deviceType;
